/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
    container: {
        textAlign: 'center',
        '& #section_id': {
            width: '35px',
            margin: 'auto',
            padding: '5px',
            fontWeight: '700',
            borderRadius: '20px',
            border: '1px solid black',
        },
        '& #section_heading': {
            fontFamily: 'ivypresto-text,PlayfairDisplayBold, serif',
            fontSize: '1.2em',
            margin: '10px auto',
        },
        '& #section_subHeading': {
            fontSize: '0.8em',
            width: '98%',
            maxWidth: '900px',
            margin: 'auto',
        },
    },
});

const Header = ({ id, heading, subHeading }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div id="section_id">{id}</div>
            <h1 id="section_heading">{heading}</h1>
            <div id="section_subHeading">{subHeading}</div>
        </div>
    );
};

Header.propTypes = {
    id: string.isRequired,
    heading: string.isRequired,
    subHeading: string.isRequired,
};

export default Header;
